import {
   AnnulledPrescription,
   findReimbursementByType,
   isIssuedForMoreThanMonth,
   RecipientCategory,
   selectAdditionalRequirementsTypes,
   ValidatedPrescription,
} from '~libs.shared.prescription';

import { SentStandardPrescription } from './SentStandardPrescriptionItem.types';

export const mapPrescriptionToSentStandardPrescription = (
   prescription: AnnulledPrescription | ValidatedPrescription,
   recipientCategory: RecipientCategory | undefined
): SentStandardPrescription => {
   const issuedForYear = isIssuedForMoreThanMonth(prescription.issuedFrom, prescription.issuedTo);

   return {
      id: prescription.id.toString(),
      annulled: prescription.annulled,
      medicinePrescription: prescription.medicinePrescription,
      type: 'standard',
      reimbursement: findReimbursementByType(
         prescription.reimbursementType ?? 'FULL',
         prescription.medicinePrescription.reimbursements
      ),
      dosage: prescription.dosage!,
      quantity: prescription.quantity,
      issuedFrom: prescription.issuedFrom,
      issuedTo: prescription.issuedTo,
      additionalEntitlementTypes: prescription.additionalEntitlementTypes,
      additionalRequirementTypes: selectAdditionalRequirementsTypes({
         cito: false, // TODO: DREGAB-3969 Waiting for implementation - cito flag
         issuedForYear: issuedForYear,
         substituteForbidden: prescription.substituteForbidden,
      }),
      preciseDosage: prescription.preciseDosage,
      extendedDosage: prescription.extendedDosage ?? null,
      treatmentDaysCount: prescription.treatmentDays,
      annullable: prescription.annullable,
      prescriptionCategory: recipientCategory,
   };
};
